<template>
  <section class="py-8">
    <div class="w-full md:w-10/12 mx-auto flex flex-col px-4 md:px-0">
      <h2 class="text-2xl font-bold">Complete Sign Up</h2>

      <div class="rounded shadow bg-white mt-5 flex flex-col sm:p-8">
        <h3 class="text-xl font-semibold mb-5">Enter your details</h3>
        <div
          v-if="isDisabled"
          class="border-l-4 border-blue-500 bg-blue-100 text-blue-800 py-5 mb-5 rounded pl-4"
        >You cannot change your details as you logged in with a Social Provider. In order to change these details you must change then with the provider.</div>
        <div class="flex flex-wrap -mx-2">
          <div class="flex-1 mx-2">
            <label
              class="inline-block uppercase tracking-wide text-gray-700 text-xs font-bold mb-3"
              for="name"
            >Name</label>
            <input
              class="appearance-none block w-full disabled:bg-gray-200 text-gray-700 border border-gray-300 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:cursor-not-allowed"
              id="name"
              v-model="clientData.name"
              type="text"
              :disabled="isDisabled"
            />
          </div>
          <div class="flex-1 mx-2">
            <label
              class="inline-block uppercase tracking-wide text-gray-700 text-xs font-bold mb-3"
              for="email"
            >Email</label>
            <input
              class="appearance-none block w-full disabled:bg-gray-200 text-gray-700 border border-gray-300 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:cursor-not-allowed"
              id="email"
              v-model="clientData.email"
              type="text"
              disabled
            />
          </div>
          <div class="flex-1 mx-2">
            <label
              class="inline-block uppercase tracking-wide text-gray-700 text-xs font-bold mb-3"
              for="sharepointTenant"
            >Sharepoint Tenant</label>
            <div
              class="w-full border rounded focus-within:border-gray-500 overflow-hidden flex"
              :class="{ 'border-gray-300': errors.tenantError == false, 'border-red-600': errors.tenantError == true, 'border-red-600': errors.duplicateError == true }"
            >
              <input
                class="appearance-none block w-full disabled:bg-gray-200 text-gray-700 py-3 px-4 leading-tight focus:outline-none focus:bg-white disabled:cursor-not-allowed"
                id="sharepointTenant"
                v-model="clientData.sharepointTenant"
                type="text"
              />
              <div class="px-4 text-gray-700 flex items-center bg-gray-200">
                <span>.sharepoint.com</span>
              </div>
            </div>
            <p
              v-if="errors.tenantError == true"
              class="mt-2 text-red-600 text-sm"
            >Sharepoint tenant can only contain lowercase, dots, and hyphens.</p>
            <p
              v-if="errors.duplicateError == true"
              class="mt-2 text-red-600 text-sm"
            >Sorry, that Sharepoint Tenant is already in use. Please use another one.</p>
          </div>
          <!-- <div class="flex-1 mx-2">
            <label
              class="inline-block uppercase tracking-wide text-gray-700 text-xs font-bold mb-3"
              for="email"
            >Plan</label>
            <div class="relative">
              <select
                v-model="selectedPlan"
                class="block appearance-none w-full disabled:bg-gray-200 border border-gray-300 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:cursor-not-allowed"
                id="grid-state"
              >
                <option
                  v-for="plan in $store.state.plans"
                  :value.sync="plan.planName"
                  :key="plan.planName"
                >{{ plan.planName }}</option>
              </select>
              <div
                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
              >
                <svg class="fill-current h-4 w-4" viewBox="0 0 20 20">
                  <path
                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                  />
                </svg>
              </div>
            </div>
            <div class="flex-2 mx-2 mt-2">
              <ul>
                <li :key="i" v-for="(feature, i) in selectedPlanFeatures">{{ feature }}</li>
              </ul>
            </div>
          </div> -->
        </div>
        <div v-if="!isPaidPlan" class="flex flex-row-reverse mt-8">
          <button
            @click="save"
            :disabled="buttonLoading"
            class="bg-green-200 hover:bg-green-300 text-green-900 font-semibold border border-green-400 rounded hover:shadow disabled:bg-green-500 disabled:cursor-not-allowed disabled:opacity-50"
          >
            <div v-if="!buttonLoading" class="inline-flex items-center py-2 px-4">
              <svg class="fill-current h-5 mr-2" viewBox="0 0 24 24">
                <path
                  d="M15,9H5V5H15M12,19A3,3 0 0,1 9,16A3,3 0 0,1 12,13A3,3 0 0,1 15,16A3,3 0 0,1 12,19M17,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V7L17,3Z"
                />
              </svg>
              <span>Save</span>
            </div>
            <div v-if="buttonLoading" class="inline-flex items-center py-2 px-10 text-white">
              <span class="mdi mdi-loading mdi-spin"></span>
            </div>
          </button>
        </div>
        <div v-if="isPaidPlan" class="flex flex-col mt-8">
          <div>
            <h4 class="text-lg font-semibold">Payment details</h4>
            <p class="mb-5">You need to add payment details to sign up for this plan.</p>
          </div>
          <div class="flex flex-row-reverse">
            <button
              @click="saveAndStripe"
              :disabled="buttonLoading"
              class="relative bg-green-200 hover:bg-green-300 text-green-900 font-semibold border border-green-400 rounded hover:shadow disabled:bg-green-500 disabled:cursor-not-allowed disabled:opacity-50"
            >
              <div class="inline-flex items-center py-2 px-4">
                <svg class="fill-current h-5 mr-2" viewBox="0 0 24 24">
                  <path
                    d="M15,9H5V5H15M12,19A3,3 0 0,1 9,16A3,3 0 0,1 12,13A3,3 0 0,1 15,16A3,3 0 0,1 12,19M17,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V7L17,3Z"
                  />
                </svg>
                <span>Save and continue to payment portal</span>
              </div>
              <div
                v-if="buttonLoading"
                class="absolute h-full w-full inline-flex items-center py-2 px-10 text-white"
              >
                <span class="mdi mdi-loading mdi-spin"></span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
</style>

<script>
import axios from "axios";
import { STRIPE_PUBLIC_KEY } from "@/utils/constants";

const stripe = window.Stripe(STRIPE_PUBLIC_KEY);

export default {
  name: "profile-start",
  mounted() {
    if (this.$store.getters.loginMethod == "google-oauth2") {
      this.isDisabled = true;
    }
    this.clientData.name = this.$store.state.loggedInUser.name;
    this.clientData.email = this.$store.state.loggedInUser.email;
    this.selectedPlan = "Free";
  },
  data() {
    return {
      isDisabled: false,
      clientData: {
        name: "",
        email: "",
        sharepointTenant: ""
      },
      selectedPlan: "",
      selectedPlanFeatures: [],
      isPaidPlan: false,
      buttonLoading: false,
      errors: {
        duplicateError: false,
        tenantError: false
      }
    };
  },
  watch: {
    selectedPlan: function() {
      this.$store.state.plans.forEach(plan => {
        if (plan.planName == this.selectedPlan) {
          this.selectedPlanFeatures = plan.planFeatures;
          this.isPaidPlan = plan.isPaidPlan;
        }
      });
    }
  },
  methods: {
    async save() {
      this.errors.duplicateError = false;
      this.errors.tenantError = false;
      this.buttonLoading = true;
      let result = new RegExp("^[a-z0-9.-]*$").test(
        this.clientData.sharepointTenant
      );
      if (result == false) {
        this.errors.tenantError = true;
        this.buttonLoading = false;
      } else {
        try {
          await axios.put("/api/complete-profile", {
            name: this.clientData.name,
            plan: this.selectedPlan,
            sharepoint_tenant: this.clientData.sharepointTenant
          });
          await this.$store.dispatch("getUserProfile");
          this.$router.push("/");
        } catch (error) {
          console.error(error);
          this.buttonLoading = false;
          if (error.response.status == 409) {
            this.errors.duplicateError = true;
          }
        }
      }
    },
    async saveAndStripe() {
      this.errors.duplicateError = false;
      this.buttonLoading = true;
      let result = new RegExp("^[a-z0-9.-]*$").test(
        this.clientData.sharepointTenant
      );
      if (result == false) {
        this.errors.tenantError = true;
        this.buttonLoading = false;
      } else {
        try {
          let response = await axios.put("/api/complete-profile", {
            name: this.clientData.name,
            plan: this.selectedPlan,
            sharepoint_tenant: this.clientData.sharepointTenant
          });
          stripe.redirectToCheckout({
            sessionId: response.data
          });
        } catch (error) {
          console.error(error);
          this.buttonLoading = false;
          if (error.response.status == 409) {
            this.errors.duplicateError = true;
          }
        }
      }
    }
  }
};
</script>